export default "__VITE_ASSET__D9whhvR8__"